import { useCallback } from "react";
import { useNavigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { Button } from "@/components/ui/button/button";
import WarningIcon from "@/components/ui/icon/warning";

import { ErrorBoundaryLayout } from "./_layout";
/**
 * @todo エラーを Sentry へ通知するか判定する処理を追加
 */
export const RootErrorBoundary = () => {
	const navigate = useNavigate();
	const handleClick = useCallback(() => {
		navigate(PATHS.TOP);
	}, [navigate]);

	return (
		<ErrorBoundaryLayout
			iconChildren={
				<div className="flex max-h-[200px] flex-col items-center gap-x-2">
					<WarningIcon className="size-[100px] text-zinc-200 laptop:size-[184px]" />

					<div>
						<p className="text-2xl font-bold tabular-nums leading-9 tracking-wider text-zinc-200 laptop:text-3xl">
							Error 500
						</p>
					</div>
				</div>
			}
			ctaChildren={
				<div className="grid gap-y-10 text-left">
					<div className="space-y-3 laptop:space-y-6">
						<h2 className="text-xl font-semibold laptop:text-4xl">システムエラーが発生しました</h2>
						<p className="text-base laptop:text-xl">時間を置いて再度お試しください</p>
					</div>

					<Button className="w-fit" variant="default" size="lg" onClick={handleClick}>
						ホームに戻る
					</Button>
				</div>
			}
		/>
	);
};
